import PropTypes from "prop-types";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

import styles from "./PlusPill.scss";

const PlusPill = ({ number }) => {
  const { getTranslation } = useRuntimeConstants();
  return (
    <span
      className={styles.container}
      data-testid="plusPill"
      aria-label={getTranslation("pdp_styled_for_you_accessibility_pill", {
        number,
      })}
    >
      +{number}
    </span>
  );
};

PlusPill.propTypes = {
  number: PropTypes.string.isRequired,
};

export default PlusPill;
